<template>
  <div class="teachers app-content">
    <div class="head-box">
      <span>当前位置： </span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">名师专题</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="teachers-list">
      <div class="list-head">
        <div class="title">授课方式</div>
        <el-radio-group v-model="radio1" size="mini">
          <el-radio-button label="综合"></el-radio-button>
          <el-radio-button label="人气"></el-radio-button>
          <el-radio-button label="好评"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="list-content">
        <teachers-list :teachersList="teachersData"></teachers-list>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import teachersList from '../components/teachersList'
const teacher = require('../../mock/teacher.json')

export default {
  name: 'teachers',
  data () {
    return {
      radio1: '综合',
      teachersData: teacher.data
    }
  },
  components: {
    teachersList
  },
  mounted () {
    this.getData(1)
  },
  methods: {
    // 获取学科数据
    getData (page) {
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olteacher/list',
        params: {
          'page': page,
          'limit': 8
        }
      }).then((result) => {
        this.teachersData = result.data.data.list
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.teachers{
  width: 1200px;
  margin: 0 auto 20px;
  .teachers-list{
    margin-top: 20px;
    .list-head{
      display: flex;
      .title{
        font-size: 18px;
        color: #333;
        width: 100px;
        line-height: 28px;
      }
    }
    .list-content{
      margin-top: 20px;
    }
  }
}
</style>
<style>
.teachers .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  background-color: #00c5c3;
  border-color: #00c5c3;
}
</style>



// WEBPACK FOOTER //
// src/view/teachers.vue